import React, { useState } from "react";
import { PiLockFill } from "react-icons/pi";
import { PiUserFill } from "react-icons/pi";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    const user = {
      email,
      password,
    };

    console.log(user);

    setEmail("");
    setPassword("");
  };

  return (
    <section className="relative min-h-screen flex justify-center items-center bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -left-40 h-96 w-96 rounded-full bg-[#064585]/30 blur-3xl" />
      <div className="pointer-events-none absolute top-32 -right-40 h-96 w-96 rounded-full bg-[#5989C8]/40 blur-3xl" />

      <div
        className="relative w-full max-w-md mx-4 p-6 sm:p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-lg shadow-2xl"
        data-aos="zoom-in-down"
      >
        <div className="text-center">
          <h1 className="text-3xl font-semibold bg-gradient-to-r from-[#64a2ff] to-[#064585] bg-clip-text text-transparent">
            Welcome Back
          </h1>
          <p className="text-slate-300 mt-1 text-sm">Login to continue</p>
        </div>

        <form className="mt-6 space-y-5">
          <div className="relative">
            <PiUserFill className="absolute left-3 top-3 text-[#5989C8]" />
            <input
              type="email"
              placeholder="Email Address"
              className="w-full pl-10 pr-3 py-2 rounded-xl border border-white/10 bg-white/10 backdrop-blur-md text-white placeholder-slate-400 focus:outline-none focus:border-[#5989C8]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="relative">
            <PiLockFill className="absolute left-3 top-3 text-[#5989C8]" />
            <input
              type="password"
              placeholder="Password"
              className="w-full pl-10 pr-3 py-2 rounded-xl border border-white/10 bg-white/10 backdrop-blur-md text-white placeholder-slate-400 focus:outline-none focus:border-[#5989C8]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {/* login button */}
          <button
            type="submit"
            className="w-full bg-[#064585] hover:bg-[#033465] text-white font-semibold py-2 rounded-full shadow-lg shadow-[#064585]/40 transition-all duration-200 hover:-translate-y-0.5"
            onClick={handleLogin}
          >
            Login
          </button>
        </form>
      </div>
    </section>
  );
};

export default Login;
